export const GOOGLE_PLAY_LINK = 'https://play.google.com/store/apps/details?id=ru.kazan.opencity';

export const APP_STORE_LINK =
  'https://apps.apple.com/ru/app/%D0%BE%D1%82%D0%BA%D1%80%D1%8B%D1%82%D0%B0%D1%8F-%D0%BA%D0%B0%D0%B7%D0%B0%D0%BD%D1%8C-%D0%B7%D0%B0%D1%8F%D0%B2%D0%BA%D0%B8/id6754276095';
